import React, { useEffect, useState } from "react";
import { usePlatformAuth } from "@/context/PlatformAuthContext";
import { ScrollText } from "lucide-react";

export default function PlatformAuditLog() {
  const { api } = usePlatformAuth();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit-log?limit=500").then((r) => setRows(r.data)); }, [api]);
  return (
    <div className="p-6 space-y-4" data-testid="platform-audit-log">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-emerald-400 font-semibold">Compliance</div>
        <h1 className="text-2xl font-heading font-semibold inline-flex items-center gap-2">
          <ScrollText className="w-5 h-5 text-slate-400" /> Platform Audit Log
        </h1>
        <p className="text-xs text-slate-500 mt-1">Every action a platform admin has taken across every organisation. Read-only.</p>
      </div>
      <div className="bg-slate-900 border border-slate-800 rounded-lg overflow-hidden">
        <table className="w-full text-xs font-mono">
          <thead className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold border-b border-slate-800">
            <tr>
              <th className="text-left px-3 py-2">When</th>
              <th className="text-left px-3 py-2">Actor</th>
              <th className="text-left px-3 py-2">Action</th>
              <th className="text-left px-3 py-2">Org</th>
              <th className="text-left px-3 py-2">Summary</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((a) => (
              <tr key={a.id} className="border-b border-slate-800/50" data-testid={`audit-row-${a.id}`}>
                <td className="px-3 py-1.5 text-slate-500">{(a.at || "").slice(0, 19).replace("T", " ")}</td>
                <td className="px-3 py-1.5 text-slate-300">{a.actor_email || "—"}</td>
                <td className="px-3 py-1.5 text-emerald-400">{a.action}</td>
                <td className="px-3 py-1.5 text-slate-400">{a.org_id || "—"}</td>
                <td className="px-3 py-1.5 text-slate-300">{a.summary || ""}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={5} className="py-8 text-center text-slate-500">No audit events yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
